import React from 'react';

export default function Header(props) {

    return (
        <div className={props.print ? "header-container hide-on-screen" : "header-container hide-on-print"}>
            <a href="/login"><img src="stateLogo.jpg" alt="State Logo" ></img></a>
        </div>
    )
}
